<template>
  <div class="dashboard-container staff-navigation">
    <button class="menu-toggle" aria-label="Apri o chiudi il menu" @click="toggleSidebar">
      <span class="material-icons">menu</span>
    </button>
    <!-- Top bar -->
    <div class="top-bar staff-top-bar">
  <a href="#" @click="goBack" class="icon-link" aria-label="Torna indietro" title="Torna indietro">
    <span class="material-icons">chevron_left</span>
  </a>
  <span>Fusco Fit Studio</span>
  <div class="icon-right">
    <!-- Mostra l'email -->

    <span v-if="userEmail" class="user-email">{{ userEmail }}</span>


    <!-- Per andare alla home -->
    <a href="#/dashboard" class="icon-link" aria-label="Apri dashboard" title="Apri dashboard">
      <span class="material-icons">home</span>
    </a>
    <!-- Logout -->
    <a href="#" @click="goLogout" class="icon-link" aria-label="Esci dall’account" title="Esci dall’account">
      <span class="material-icons">logout</span>
    </a>
  </div>
</div>



    <div v-if="isLoading" class="loader">Caricamento in corso...</div>

    <!-- Sidebar e contenuto principale -->
    <div class="menu-sidebar">
      <!-- Sidebar -->
      <aside class="sidebar staff-sidebar staff-sidebar-modern">
        <div class="staff-sidebar-brand">
          <img
            src="https://www.metodofusco.it/media/white.png"
            class="staff-sidebar-brand-logo"
            alt="Fusco Fit"
          >
          <div class="staff-sidebar-workspace">
            <span>Workspace</span>
            <strong>Staff</strong>
          </div>
        </div>

        <nav class="staff-sidebar-nav" aria-label="Navigazione principale staff">
          <section
            v-for="group in navigationGroups"
            :key="group.id"
            class="staff-nav-group"
            :aria-labelledby="'staff-nav-' + group.id"
          >
            <h2 :id="'staff-nav-' + group.id" class="staff-nav-group-title">{{ group.label }}</h2>
            <ul class="staff-nav-list">
              <li v-for="item in group.items" :key="item.id">
                <RouterLink
                  :to="item.to"
                  :class="['staff-nav-link', { 'is-current': item.id === activeNavigationId }]"
                  :aria-current="item.id === activeNavigationId ? 'page' : null"
                >
                  <span class="staff-nav-icon material-icons" aria-hidden="true">{{ item.icon }}</span>
                  <span class="staff-nav-copy">
                    <span class="staff-nav-title-row">
                      <span class="staff-nav-title">{{ item.label }}</span>
                      <span v-if="item.isNew" class="staff-nav-new" title="Novità" aria-label="Novità"></span>
                    </span>
                    <span class="staff-nav-description">{{ item.description }}</span>
                  </span>
                </RouterLink>
              </li>
            </ul>
          </section>
        </nav>
      </aside>
    </div>
  </div>
</template>

<script>
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { staffNavigationGroups, getStaffNavigationActiveId } from '../lib/staffNavigation';

export default {
  components: { RouterLink },
  methods: {

    async handleLogin() {
    const email = this.emailInput; // Input dell'email
    const password = this.passwordInput; // Input della password

    try {
      await this.$store.dispatch('login', { email, password });
      console.log('Login avvenuto con successo!');
    } catch (error) {
      console.error('Errore durante il login:', error);
    }
  },

    toggleSidebar() {
    const sidebar = document.querySelector('.menu-sidebar .sidebar');
    if (sidebar) {
      sidebar.classList.toggle('active');
    }

    const contentContainer = document.querySelector('.content-container');
    if (contentContainer) {
      contentContainer.classList.toggle('sidebar-hidden');
    }

    const topBar = document.querySelector('.top-bar');
    if (topBar) {
      topBar.classList.toggle('sidebar-hidden');
    }

    const modal = document.querySelector('.modal');
    if (modal) {
      modal.classList.toggle('sidebar-hidden');
    }
  }
},
  name: 'SidebarComponent',
  setup() {

  const store = useStore(); // Inizializza lo store prima di accedere ai getter
  const router = useRouter();
  const route = useRoute();
  const activeNavigationId = computed(() => getStaffNavigationActiveId(route));

  const isLoading = computed(() => store.getters.isLoading);
  const user = computed(() => store.getters.user);
  const userToken = computed(() => store.getters.userToken);
  const userEmail = ref(localStorage.getItem('userEmail'));





    
    const goBack = () => {
      router.go(-1);
    };

    const goToTickets = () => {
      router.push('/admin');
    };

    const goToAndamento = () => {
      router.push('/invii-giornata');
    };

    const goToInviiDaModificare = () => {
      router.push('/invii-da-modificare');
    };

   const goToDash = () => {
      router.push('/dashboard');
    };

    

        const goToCheck = () => {
      router.push('/check-dafare');
    };


    const goToTecnica = () => {
      router.push('/assistenzatecnica');
    };

    const goToOrders = () => {
      router.push('/order-list-new');
    };

    const goToUsers = () => {
      router.push('/users-list');
    };


    const goToProcedure = () => {
      router.push('/procedure');
    };

    const goToProducts = () => {
      router.push('/products');
    };

    const goToGestione = () => {
      router.push('/gestione-general');
    };

    const goToEvent = () => {
      router.push('/booking-general');
    };

    const goLogout = async () => {
      try {
        await store.dispatch('logout');
      } catch (error) {
        console.error("Errore durante il logout:", error);
      }
    };

    return {
      navigationGroups: staffNavigationGroups,
      activeNavigationId,
      goToTickets,
      goLogout,
      user,
      userToken,
      goBack,
      goToOrders,
      goToUsers,
      goToProducts,
      isLoading,
      goToEvent,
      goToTecnica,
      goToProcedure,
      goToAndamento,
      goToInviiDaModificare,
      userEmail,
      goToGestione,
      goToCheck,
      goToDash
    };
  }
};
</script>

  


<style scoped>

.user-email {
  font-weight: bold;
  margin-right: 10px;
  align-items: center;

}

.loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.top-bar {
  position: fixed;
  top: 10px;
  right: 10px;
  width: calc(100% - 337px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background: linear-gradient(45deg, #b0b0b0 0%, #cfcfcf 100%);
  color: #000000;
  text-align: left;
  border-radius: 23px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  z-index: 1000;
}

.top-bar.sidebar-hidden {
  width: calc(100% - 70px);
}

.icon-link {
  padding: 0;
}

.icon-right {
  display: flex;
  align-items: center;
}

.icon-right a:not(:last-child) {
  margin-right: 10px;
}

.menu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #c8c8c8; 
  color: #000000;
  border-radius: 23px;
  margin-bottom: 20px;
  margin-top: 10px;
  padding-top: 7px;
  padding-bottom: 7px;
  padding-left: 13px;
  padding-right: 18px;
  margin-left: 15px;
  margin-right: 15px;
  position: relative;
  border: none;
}

.menu-sidebar .sidebar {
  width: 277px;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  background-color: #dcdcdc;
  overflow-y: auto;
  box-shadow: 2px 0 5px rgba(0,0,0,0.1);
  z-index: 1001;
  transition: left 0.3s;
}

.menu-sidebar .sidebar.active {
  left: -277px;
}

.sidebar-logo {
  padding: 10px;
  text-align: center;
  background: #dcdcdc;
  margin-top: 50px;
  margin-bottom: 50px;
}

.logo-sidebar {
  width: 120px;
  padding-top: 0px;
}

.sidebar-menu ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.icon-column {
  padding-right: 0px;
  padding-left: 7px;
}

.text-column {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  margin-top: 7px;
  margin-bottom: 7px;
}

.header-text {
  font-weight: bold;
  margin-bottom: 5px;
}

.text-card {
  font-size: smaller;
  color: #2e2e2e;
}

.icon-column-right {
  margin-left: auto;
}

.material-icons {
  font-size: 24px;
  color: #353535;
  margin-right: 8px;
}

.new-badge {
  background-color: #c40000;
  color: white;
  font-size: 0.7em;
  padding: 5px 6px;
  border-radius: 10px;
  margin-left: 5px;
}

.menu-toggle {
  position: fixed;
  top: 10px;
  left: 10px;
  z-index: 1003;
  padding: 15px;
  background-color: rgba(0, 255, 255, 0);
  color: #00ad23;
  border: none;
  display: block;
}



@media (max-width: 768px) {
  .menu-sidebar .sidebar {
    width: 90%;
    left: -100%;
  }

  .menu-sidebar .sidebar.active {
    left: 0;
  }

  .top-bar {
    top: 10px;
    right: 3px;
    width: 75%;
    background: linear-gradient(45deg, #161616 0%, #161616 100%);
  }

  .menu-toggle {
    display: block;
  }
}


@media (max-width: 768px) {
  .staff-navigation .staff-top-bar,
  .staff-navigation .staff-top-bar.sidebar-hidden {
    box-sizing: border-box;
    top: 8px;
    left: 56px;
    right: 8px;
    width: auto;
    height: 48px;
    display: grid;
    grid-template-columns: 36px minmax(0, 1fr) 36px 36px;
    grid-template-rows: 18px 16px;
    column-gap: 2px;
    align-content: center;
    padding: 4px 6px;
    border: 1px solid #d1d5db;
    border-radius: 12px;
    background: linear-gradient(45deg, #e5e7eb 0%, #f3f4f6 100%);
    color: #1f2937;
    box-shadow: 0 2px 6px rgba(15, 23, 42, 0.08);
  }

  .staff-top-bar > span {
    grid-column: 2;
    grid-row: 1;
    min-width: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 12px;
    line-height: 18px;
    font-weight: 600;
  }

  .staff-top-bar .icon-right {
    display: contents;
  }

  .staff-top-bar .user-email {
    grid-column: 2;
    grid-row: 2;
    min-width: 0;
    margin: 0;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 10px;
    line-height: 16px;
    font-weight: 400;
    color: #4b5563;
  }

  .staff-top-bar .icon-link {
    grid-row: 1 / 3;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 40px;
    margin: 0;
    padding: 0;
    border-radius: 8px;
    color: #374151;
    text-decoration: none;
  }

  .staff-top-bar > .icon-link {
    grid-column: 1;
  }

  .staff-top-bar .icon-right > a:first-of-type {
    grid-column: 3;
    margin-right: 0;
  }

  .staff-top-bar .icon-right > a:last-of-type {
    grid-column: 4;
  }

  .staff-top-bar .material-icons {
    margin: 0;
    font-size: 22px;
    color: #374151;
  }

  .staff-navigation .menu-toggle {
    box-sizing: border-box;
    top: 8px;
    left: 8px;
    width: 40px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .staff-navigation .menu-toggle .material-icons {
    margin: 0;
  }
}

</style>

<style scoped src="../assets/css/staff-sidebar-compact.css"></style>
<style src="../assets/css/staff-sidebar-layout.css"></style>

<style scoped src="../assets/css/staff-sidebar-modern.css"></style>
<style scoped src="../assets/css/staff-topbar-refined.css"></style>
